"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fonts = void 0;
exports.fonts = {
    family: {
        fontSans: 'Open Sans, Arial, Verdana, sans-serif',
    },
    sizes: {
        font3xs: '0.64rem',
        font2xs: '0.8rem',
        fontXs: '1rem',
        fontSm: '1.25rem',
        fontMd: '1.563rem',
        fontLg: '1.953rem',
        fontXl: '2.441rem',
        font2xl: '3.052rem',
        font3xl: '3.815rem',
    },
    weight: {
        fontLight: 300,
        fontNormal: 400,
        fontSemiBold: 600,
        fontBold: 700,
        fontExtraBold: 800,
    },
    align: {
        center: 'center',
        end: 'end',
        left: 'left',
        right: 'right',
    },
};
//# sourceMappingURL=fonts.js.map